export default __webpack_public_path__ + "static/media/29.c0b08cb0.png";